import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import { ApiHelper } from "../../../helpers";
import { message } from "../../../common";
import { ApiRoutes, AppRoutes } from "../../../config";
import { InputTextField, SubmitButton } from "../../components/forms";
import fileMinusIcon from "../../../assets/img/file-minus.svg";
import tagIcon from "../../../assets/img/shape-copy.svg";
import calenderIcon from "../../../assets/img/calender.svg";

const PrintBatchModal = ({
  batchData = {},
  open,
  // itemCount = '',
  // printBatchError = '',
  // onChange,
  // handlePrint,
  handleClose,
  fetchData,
  fetchHistory,
}) => {
  // Item count admin wants to print
  const [itemCount, setItemCount] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const {
    batchNumber = "",
    availableUnits = 0,
    // product = [],
    productName = "",
    _id = "",
  } = batchData;
  useEffect(() => {
    setItemCount("");
    setError("");
  }, [open]);
  const assignBatchToPHL = async () => {
    setLoading(true);
    const response = await new ApiHelper().FetchFromServer(
      ApiRoutes.ASSIGN_BATCH.service,
      ApiRoutes.ASSIGN_BATCH.url.replace(":id", _id),
      ApiRoutes.ASSIGN_BATCH.method,
      ApiRoutes.ASSIGN_BATCH.authenticate,
      undefined,
      { unit: itemCount }
    );
    setLoading(false);
    if (response && response.isError) {
      toast.error(response.messages[0]);
    } else {
      const {
        data: { batchGroup },
      } = response.data;
      handleClose();
      fetchData();
      if (fetchHistory) {
        fetchHistory();
      }
      let mapObj = {
        ":id": _id,
        ":unit": itemCount,
      };
      var re = new RegExp(Object.keys(mapObj).join("|"), "gi");
      window.open(
        `${AppRoutes.PRINT_BATCH.replace(re, function (matched) {
          return mapObj[matched.toLowerCase()];
        })}?group=${batchGroup}`,
        "_blank"
      );
    }
  };
  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setItemCount(value);
    setError("");
  };
  const handlePrint = async () => {
    let errorMsg = "";
    // To validate item count
    if (!itemCount) {
      errorMsg = message.Required.replace(":item", "Item count");
    } else if (!Number.isInteger(Number(itemCount))) {
      errorMsg = message.InvalidItemCount;
    } else if (Number(itemCount) <= 0) {
      errorMsg = message.MinItemCount;
    } else if (Number(itemCount) > availableUnits) {
      errorMsg = message.PrintBatchError.replace(":count", availableUnits);
    }
    if (errorMsg) {
      setError(errorMsg);
    } else {
      await assignBatchToPHL();
    }
  };
  return (
    <Modal
      show={open}
      onHide={handleClose}
      dialogClassName="modal-30w"
      restoreFocus={false}
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header closeButton>
        <Modal.Title>Print Batch</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="row mb-2">
          <div className="col-md-6">
            <div className="heading-col">
              <img src={fileMinusIcon} alt="" />
              <h5>Batch Number</h5>
            </div>
            <div className="description-col">
              <h5>{batchNumber}</h5>
            </div>
          </div>
          <div className="col-md-6">
            <div className="heading-col">
              <img src={tagIcon} alt="" />
              <h5>Product Name</h5>
            </div>
            <div className="description-col">
              <h5>
                {productName}
                {/* {product && product.length ? product[0].productName : '-'} */}
              </h5>
            </div>
          </div>
        </div>
        <div className="row mb-3">
          <div className="col-md-6">
            <div className="heading-col">
              <img src={calenderIcon} alt="" />
              <h5>Available Count</h5>
            </div>
            <div className="description-col">
              <h5>{availableUnits}</h5>
            </div>
          </div>
        </div>

        <div className="form-group">
          <div className={"text-danger"}></div>
          <InputTextField
            id="item_count"
            type={"number"}
            placeholder={"Enter Item Count"}
            className={"form-control-input-modal"}
            name="itemCount"
            value={itemCount}
            onChange={handleChange}
            errorMessage={error}
          />
        </div>
      </Modal.Body>

      <Modal.Footer>
        <div className="col-md-12 footer-form d-flex align-items-center">
          <button
            className="btn btn-primary cancel-btn modal-btn-ft active-cancel-btn"
            onClick={handleClose}
            disabled={loading}
          >
            {" "}
            CANCEL
          </button>

          <SubmitButton
            className={"submit-btn modal-btn-ft"}
            text={"PRINT"}
            isLoading={loading}
            onSubmit={handlePrint}
          />
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default PrintBatchModal;
